import React from "react";
import { Routes, Route } from "react-router-dom";
import AuthRoute from "../../actions/AuthRoute";
import HomePage from "../../pages/Home";
import LoginPage from "../../pages/Login";
import GARFOIvr from "../../pages/GarfoIvrPage/GARFOIvr";
import ManageIvrTrip from "../../pages/GarfoIvrPage/ManageIvrTrip";
import StartNewTrip from "../../pages/StartNewTrip";
import GARFOVtr from "../../pages/GarfoVtrPage/GARFOVtr";
import NoEffortPage from "../../pages/NoEffortPage";
import CatchPage from "../../pages/CatchPage";
import LandingDate from "../../pages/LandingDatePage";
import SalesWizardPage from "../../pages/SalesWizardPage";
import EditSales from "../../pages/EditSales";
import SignVtrPage from "../../pages/SignVtrPage";
import TripTypePage from "../../pages/TripTypePage";
import OperatorVesselPermitPage from "../../pages/OperatorVesselPermitPage";
import DateSail from "../../pages/DateSailPage/DateSail";
import EffortPage from "../../pages/EffortPage";
import EffortPage1 from "../../pages/EffortPage1";
import EffortPage2 from "../../pages/EffortPage2";
import EffortPage3 from "../../pages/EffortPage3";
import EffortPage4 from "../../pages/EffortPage4/EffortPage4";
import EffortReviewPage from "../../pages/EffortReviewPage";
import VtrTrip from "../../pages/VtrTrip";
import ReDeclare from "../../pages/GarfoIvrPage/VmsCodePage";
import OpenBlock from "../../pages/GarfoIvrPage/OpenDasBlockPage";
import Messages from "../../pages/MessagesPage/MessagesPage";
import OAuthLogin from "../OAuthLogin/OAuthLogin";
import ErrorPage from "../../pages/ErrorPage/ErrorPage";

const Routing = () => {
  return (
    <Routes>
      <Route path={process.env.PUBLIC_URL} element={<AuthRoute />}>
        <Route path="home" element={<HomePage />} />
        <Route path="start-new-trip" element={<StartNewTrip />} />
        <Route path="vtr" element={<GARFOVtr />} />
        <Route path="no-effort" element={<NoEffortPage />} />
        <Route path="vtr-catch" element={<CatchPage />} />
        <Route path="landing-date" element={<LandingDate />} />
        <Route path="sales-wizard" element={<SalesWizardPage />} />
        <Route path="sales-edit" element={<EditSales />} />
        <Route path="sign-vtr" element={<SignVtrPage />} />
        <Route path="trip-type" element={<TripTypePage />} />
        <Route path="operator-vessel" element={<OperatorVesselPermitPage />} />
        <Route path="date-sail" element={<DateSail />} />
        <Route path="effort-wizard" element={<EffortPage />} />
        <Route path="effort-page1" element={<EffortPage1 />} />
        <Route path="effort-page2" element={<EffortPage2 />} />
        <Route path="effort-page3" element={<EffortPage3 />} />
        <Route path="effort-page4" element={<EffortPage4 />} />
        <Route path="effort-review" element={<EffortReviewPage />} />
        <Route path="vtr-trip-review" element={<VtrTrip />} />
        <Route path="ivr" element={<GARFOIvr />} />
        <Route path="new-ivr-trip" element={<ManageIvrTrip />} />
        <Route path="ivr-close-trip" element={<ManageIvrTrip />} />
        <Route path="ivr-das-trip" element={<ManageIvrTrip />} />
        <Route path="das-open-block" element={<OpenBlock />} />
        <Route path="vms-declaration" element={<ReDeclare />} />
        <Route path="broadcasted-messages" element={<Messages />} />
        <Route path="*" element={<ErrorPage />} />
      </Route>
      <Route
        path={`${process.env.PUBLIC_URL}/oauth_login`}
        element={<OAuthLogin />}
      />
      <Route path={`${process.env.PUBLIC_URL}/login`} element={<LoginPage />} />
    </Routes>
  );
};

export default Routing;
